function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Observable } from 'relay-runtime';
var uid = 0;

function getFormData(_ref, uploadables) {
  var id = _ref.id,
      query = _ref.query,
      variables = _ref.variables;
  var formData = new FormData();
  formData.append('id', id);
  formData.append('query', query);
  formData.append('variables', JSON.stringify(variables));
  Object.keys(uploadables).forEach(function (key) {
    formData.append(key, uploadables[key]);
  });
  return formData;
}

var batcher = null;

function normalizeBatch(batch) {
  if (batch === void 0) {
    batch = true;
  }

  var p = typeof batch === 'boolean' ? {
    enabled: batch
  } : {};
  return _extends({
    timeoutMs: 0
  }, p);
}

function normalizeAuth(auth) {
  if (auth === void 0) {
    auth = '';
  }

  var p = typeof auth === 'string' ? {
    token: auth
  } : auth;
  return _extends({
    token: '',
    scheme: 'Bearer',
    headerName: 'Authorization'
  }, p);
}

function createFetch(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$url = _ref2.url,
      url = _ref2$url === void 0 ? '/graphql' : _ref2$url,
      initOrThunk = _ref2.init,
      authorization = _ref2.authorization,
      _ref2$throwErrors = _ref2.throwErrors,
      throwErrors = _ref2$throwErrors === void 0 ? true : _ref2$throwErrors,
      batch = _ref2.batch;

  var batching = normalizeBatch(batch);
  var auth = normalizeAuth(authorization);

  function processJson(json) {
    if (throwErrors && (json === null || json === void 0 ? void 0 : json.errors)) {
      var gqlError = new Error("GraphQLError: \n\n" + JSON.stringify(json.errors));
      gqlError.json = json;
      throw gqlError;
    }

    return json;
  }

  function makeRequest(body, signal) {
    var init = typeof initOrThunk === 'function' ? initOrThunk() : initOrThunk;
    var headers = new Headers(init === null || init === void 0 ? void 0 : init.headers);

    if (auth.token) {
      headers.set(auth.headerName, auth.scheme + " " + auth.token);
    }

    if (!headers.has('Accept')) {
      headers.set('Accept', '*/*');
    }

    if (typeof body === 'string' && !headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }

    return fetch(url, _extends({
      method: 'POST'
    }, init, {
      body: body,
      signal: signal,
      headers: headers
    })).then(function (resp) {
      if (!resp.ok) {
        return resp.text().then(function (txt) {
          var httpError = new Error("RelayNetworkLayerError: [" + resp.status + "]: " + txt);
          httpError.status = resp.status;
          throw httpError;
        });
      }

      return resp.json();
    });
  }
  /**
   * Queues a single request, that is flushed on the next tick (or `batchTimeout`).
   */


  function addToBatch(reqBody, reqSink) {
    if (!batcher) {
      batcher = {
        bodies: [],
        sinks: []
      };
      setTimeout(function () {
        var _ref3 = batcher,
            bodies = _ref3.bodies,
            sinks = _ref3.sinks;
        batcher = null;
        makeRequest("[" + bodies.join(',') + "]").then(function (batchResp) {
          if (!batchResp || !Array.isArray(batchResp)) {
            throw new Error('RelayNetworkLayerError: invalid batch response, must return a JSON array');
          }

          if (batchResp.length !== sinks.length) {
            throw new Error("RelayNetworkLayerError: invalid batch response, mismatched length, sent requests for " + sinks.length + " queries but received: " + batchResp.length);
          } // Match the response with the sink and finish each request


          sinks.forEach(function (sink, idx) {
            try {
              var resp = processJson(batchResp[idx]);
              sink.next(resp);
              sink.complete();
            } catch (err) {
              sink.error(err);
            }
          });
        }) // The catch is here instead of the 2nd then argument to ensure on
        // general errors all sinks are closed. For individual request errors
        // those are caught above in the loop so wouldn't make it here
        .catch(function (err) {
          sinks.forEach(function (s) {
            return s.error(err);
          });
        });
      }, batching.timeoutMs);
    }

    batcher.bodies.push(reqBody);
    batcher.sinks.push(reqSink);
  }

  function fetchFn(operation, variables, _cacheConfig, uploadables) {
    // We use observables directly here instead of the promise value
    // in order to express Aborted requests unambiguously: completed with
    // no value sent.
    return Observable.create(function (sink) {
      var data = {
        id: operation.id || operation.name || String(uid++),
        query: operation.text || '',
        variables: variables
      };
      var body = uploadables ? getFormData(data, uploadables) : JSON.stringify(data);

      if (batching.enabled && !uploadables && operation.operationKind !== 'mutation') {
        addToBatch(body, sink);
        return undefined;
      }

      var controller = window.AbortController ? new window.AbortController() : null;
      makeRequest(body, controller === null || controller === void 0 ? void 0 : controller.signal).then(processJson).then(function (value) {
        sink.next(value);
        sink.complete();
      }, function (err) {
        if ((err === null || err === void 0 ? void 0 : err.name) === 'AbortError') sink.complete();else sink.error(err);
      });
      return function () {
        controller === null || controller === void 0 ? void 0 : controller.abort();
      };
    });
  }

  return fetchFn;
}

export default createFetch;